module.exports = __webpack_public_path__ + "static/19-11ee25630e30d9f74ceeee339242b3f7.jpg";